import getThemeClassName from '~/client/shared/ThemeProviders/helpers/getThemeClassName';
import useSite from '../useSite';

const useThemeClassName = (colorScheme: ColorScheme) => {
  const { site } = useSite();
  return getThemeClassName(colorScheme, site);
};

export default useThemeClassName;
